import React, { useEffect, createElement } from 'react';
import { DoSomeMartialArtsHeroInfo } from './do-some-martial-arts/DoSomeMartialArtsHeroInfo';
import { DoSomeMartialArtsHeroForm } from './do-some-martial-arts/DoSomeMartialArtsHeroForm';
import { DoSomeMartialArtsWhyMartialArts } from './do-some-martial-arts/DoSomeMartialArtsWhyMartialArts';
import { DoSomeMartialArtsWhyTaekwondo } from './do-some-martial-arts/DoSomeMartialArtsWhyTaekwondo';
import { DoSomeMartialArtsClasses } from './do-some-martial-arts/DoSomeMartialArtsClasses';
import { DoSomeMartialArtsFirstVisit } from './do-some-martial-arts/DoSomeMartialArtsFirstVisit';
import { DoSomeMartialArtsReviews } from './do-some-martial-arts/DoSomeMartialArtsReviews';
import { DoSomeMartialArtsServiceAreas } from './do-some-martial-arts/DoSomeMartialArtsServiceAreas';
import { DoSomeMartialArtsFAQHeader } from './do-some-martial-arts/DoSomeMartialArtsFAQHeader';
import { DoSomeMartialArtsFAQQuestions } from './do-some-martial-arts/DoSomeMartialArtsFAQQuestions';
import { DoSomeMartialArtsRelatedLinks } from './do-some-martial-arts/DoSomeMartialArtsRelatedLinks';
import { DoSomeMartialArtsFinalCTA } from './do-some-martial-arts/DoSomeMartialArtsFinalCTA';
import { SITE_IMAGES } from '../components/siteImages';
export function DoSomeMartialArts() {
  useEffect(() => {
    document.title = 'Thinking About Trying Martial Arts? | Storm Taekwondo Farmington Hills';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Want to try martial arts? Storm Taekwondo in Farmington Hills is beginner-friendly for kids, adults, and families. No experience needed. Start with a trial class.';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-1027">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-1028">
        <div className="absolute inset-0 opacity-25" data-id="element-1029">
          <img src={SITE_IMAGES.heroHome} alt="Storm Taekwondo students training in Farmington Hills" className="block w-full h-full object-cover" data-id="element-1030" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-1031" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1032">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-1033">
            <DoSomeMartialArtsHeroInfo data-id="element-1034" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-1035">
              <DoSomeMartialArtsHeroForm data-id="element-1036" />
            </div>
          </div>
        </div>
      </section>
      <DoSomeMartialArtsWhyMartialArts data-id="element-1037" />
      <DoSomeMartialArtsWhyTaekwondo data-id="element-1038" />
      <DoSomeMartialArtsClasses data-id="element-1039" />
      <DoSomeMartialArtsFirstVisit data-id="element-1040" />
      <DoSomeMartialArtsReviews data-id="element-1041" />
      <DoSomeMartialArtsServiceAreas data-id="element-1042" />
      <section className="py-24 bg-off-white" data-id="element-1043">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1044">
          <DoSomeMartialArtsFAQHeader data-id="element-1045" />
          <DoSomeMartialArtsFAQQuestions data-id="element-1046" />
        </div>
      </section>
      <DoSomeMartialArtsRelatedLinks data-id="element-1047" />
      <DoSomeMartialArtsFinalCTA data-id="element-1048" />
    </div>;
}